export class PharmacyControl {
    Id: number;
    Title: string;
    ForeignTitle: string;
    constructor() { }
}